{
  "jobLabel": "Job",
  "close": "Close",
  "cancel": "Cancel",
  "cancelled": "Cancelled",
  "onHold": "On Hold",
  "ok": "OK",
  "allow": "Allow",
  "confirm": "Confirm",
  "dismiss": "Dismiss",
  "pleaseWait": "Please wait...",
  "about": "About",
  "version": "Version",
  "callUs": "Call Us",
  "emailUs": "Email Us",
  "privacyPolicy": "Privacy Policy",
  "termsOfService": "Terms of Service",
  "profile": "Profile",
  "contact": "Contact",
  "editProfile": "Edit Profile",
  "menu": "Menu",
  "paymentCards": "Payment Cards",
  "address": "Address",
  "pointOfInterest": "Point of Interest",
  "myAddresses": "My Addresses",
  "operatorLogo": "Operator logo",
  "search": "Search",
  "goodsTypes": {
    "passenger": "Passenger | Passengers",
    "passengers": "1 passenger | {count} passengers",
    "parcel": "Parcel | Parcels",
    "parcels": "1 parcel | {count} parcels",
    "pallet": "Pallet | Pallets",
    "pallets": "1 pallet | {count} pallets",
    "internationalParcel": "International Parcel | International Parcels",
    "internationalParcels": "1 international parcel | {count} international parcels",
    "overnightParcel": "Overnight Parcel | Overnight Parcels",
    "overnightParcels": "1 overnight parcel | {count} overnight parcels",
    "good": "Good | Goods",
    "goods": "1 good | {count} goods"
  },
  "bags": "1 bag | {count} bags",
  "cartons": "1 carton | {count} cartons",
  "newBooking": {
    "title": "New Booking",
    "button": "New Booking"
  },
  "editBooking": "Edit Booking",
  "errorOccured": "An error has occurred - please try again",
  "errorCalculatingRoute": "Error calculating route",
  "addStop": "Add Stop",
  "searchAddress": "Search Address",
  "addressTypes": "Address Types",
  "noBookingDetails": "No booking details available",
  "pickupDelay": "{dateString} (~{delay} mins)",
  "performingQuote": "Performing quote",
  "n/a": "Not available",
  "approx": "approx",
  "est": "Est.",
  "earliest": "Earliest {dt}",
  "pickup": "Pickup {dt}",
  "arrive": "Arrive {dt}",
  "back": "",
  "areYouSure": "Are you sure?",
  "alertBack": "Back",
  "lastRefreshed": "Last refreshed: ",
  "storedAddressLabel": "Addresses",
  "deleteAddress": "Delete Address",
  "noStoredAddressDetails": "No addresses available",
  "alertFilter": "Filter",
  "alertYourAddresses": "Your addresses",
  "alertAccountAddresses": "Account addresses",
  "alertRecentAddresses": "Recent addresses",
  "groupYourAddresses": "Your addresses",
  "groupAccountAddresses": "Account addresses",
  "groupRecentAddresses": "Recent addresses",
  "buttonAddressBookFrom": "Book from...",
  "buttonAddressBookTo": "Book to...",
  "buttonAddressEdit": "Edit",
  "mapSearch": "Map Search",
  "noAddressesFound": "No addresses found",
  "noCountriesFound": "No countries found",
  "save": "Save",
  "remove": "Remove",
  "signOutConfirmation": "Do you want to sign out?",
  "exitAppConfirmation": "Do you want to exit the app?",
  "minute": "min",
  "hour": "hr",
  "booking": "Booking",
  "noBookingTemplates": "No booking templates available",
  "reporting": {
    "title": "Reports",
    "selectReport": "Select report",
    "updateReportButton": "Update report",
    "noReportsAvailable": "No reports available",
    "noReportSelected": "No report selected",
    "filters": "Report filters",
    "export": {
      "copy": "Copy",
      "csv": "CSV",
      "xls": "Excel",
      "pdf": "PDF"
    }
  },
  "actions": "Actions",
  "noMop": "No methods of payment available",
  "flightSearch": {
    "title": "Flight Search",
    "addFlightDetails": "Add flight details",
    "noFlightsFound": "No flights found",
    "flightWarning": "Flight Warning",
    "airportArriveWarningMessage": "Please double check selected flight, we don't think it arrives at the airport you have selected",
    "airportDepartWarningMessage": "Please double check selected flight, we don't think it departs from the airport you have selected",
    "terminalArriveWarningMessage": "Please double check selected flight, we don't think it arrives at the terminal you have selected",
    "terminalDepartWarningMessage": "Please double check selected flight, we don't think it departs from the terminal you have selected",
    "matchFlightTimeHeader": "Match flight time?",
    "matchFlightTimeMessage": "Would you like to match the booking time with the flight arrival time?",
    "selectedAirport": "Selected Airport: {airportCode}",
    "flightAirport": "Flight Airport: {airportCode}",
    "flightTerminal": "Flight Terminal: {terminal}",
    "searchButton": "Search for Flights"
  },
  "to": "to",
  "from": "from",
  "noContactsFound": "No contacts found",
  "maintainContact": "Maintain Contact",
  "bookAs": "Book as",
  "leadPassenger": "Lead Passenger",
  "bookAsWarning": "To complete this booking you will switch to booking as {contactName}",
  "webAccess": {
    "addJobsMessage": "Sorry, you don't have access rights to create a new booking, please call {companyTelephoneNumber}",
    "editJobsMessage": "Sorry, you don't have access rights to edit this booking, please call {companyTelephoneNumber}",
    "cancelJobsMessage": "Sorry, you don't have access rights to cancel this booking, please call {companyTelephoneNumber}",
    "addCardsMessage": "Sorry, you don't have access rights to add payment cards, please call {companyTelephoneNumber}",
    "editContactsMessage": "Sorry, you don't have access rights to edit this contact, please call {companyTelephoneNumber}",
    "addAddressesMessage": "Sorry, you don't have access rights to add addresses, please call {companyTelephoneNumber}",
    "editAddressesMessage": "Sorry, you don't have access rights to edit addresses, please call {companyTelephoneNumber}",
    "deleteAddressesMessage": "Sorry, you don't have access rights to delete addresses, please call {companyTelephoneNumber}",
    "canRequestMessage": "Sorry, you don't have access rights to request contact link access, please call {companyTelephoneNumber}"
  },
  "approved": "Approved",
  "contactLink": {
    "contactLink": "Contact Link",
    "linkNewContact": "Link New Contact",
    "linkedContacts": "Linked Contacts",
    "noLinkedContacts": "No Linked Contacts",
    "pendingLinkedContacts": "Pending Linked Contacts",
    "noPendingLinkedContacts": "No Pending Linked Contacts",
    "authoriseContactLink": "Authorise Contact Link?",
    "confirmOrRejectContactLink": "Do you want to confirm or reject this contact link?",
    "description": "Need to make bookings on behalf of a colleague, or maintain their profile? Request access by entering their email address below, they will receive a notification that you would like access to their profile.",
    "pending": "Pending",
    "reject": "Reject"
  },
  "jobCalendar": {
    "eventTitle": "{companyName}: {firstStop} to {lastStop}",
    "pickup": "Pickup: {address}",
    "via": "Via: {address}",
    "dropOff": "Drop off: {address}",
    "journeyTime": "Estimated journey time: {duration}",
    "trackingLink": "Track your journey: {url}"
  },
  "jobSharing": {
    "shareRideDetails": "Share ride details",
    "iAm": "I am",
    "personIs": "{person} is",
    "shareMessage": "travelling with {companyName} from {firstStop} to {lastStop} on {dt}"
  },
  "noEditAccess": "No edit access",
  "noBookingAccess": "No access to booking",
  "invalidBooking": "Invalid booking details",
  "adminConsole": "Admin Console",
  "cookieConsent": {
    "message": "We use cookies to improve your experience and provide essential services. By continuing to browse our website, you consent to the use of cookies. For more information, please read our",
    "privacyPolicy": "Privacy Policy",
    "accept": "Accept",
    "dismiss": "Dismiss"
  },
  "eta": "ETA: {eta}",
  "settings": "Settings",
  "language": "Language",
  "appearance": {
    "label": "Appearance",
    "system": "System",
    "light": "Light",
    "dark": "Dark"
  },
  "bookingButtons": {
    "addFavourite": "Add Favourite",
    "clearFavourite": "Clear Favourite",
    "edit": "Edit",
    "share": "Share",
    "sendConfirmation": "Send Confirmation",
    "copy": "Copy",
    "return": "Return",
    "cancel": "Cancel",
    "addToCalendar": "Add to Calendar",
    "more": "More"
  },
  "date": "Date",
  "time": "Time",
  "price": {
    "taxIncluded": "(Inc {tax} VAT)",
    "saving": "Saving {amount}"
  },
  "distance": {
    "outputText": "Distance {distance}",
    "extraText": "Please note that journey distances are only estimations",
    "metresAway": "{distance} metres away",
    "kilometresAway": "{distance} km away",
    "feetAway": "{distance} feet away",
    "milesAway": "{distance} miles away",
    "miles": "{distance} mile | {distance} miles",
    "kilometres": "{distance} km"
  },
  "journey": {
    "outputText": "Journey {journey}",
    "extraText": "Please note that journey times are only estimations"
  },
  "betweenTwoStrings": "Between {first} and {second}",
  "quickQuote": "Quote",
  "bookingConfirmation": {
    "newTitle": "Booking Confirmed",
    "editTitle": "Booking Edited",
    "navigationCountdown": "Closing in { secondsRemaining }s",
    "navigateButton": "View / Manage Booking"
  },
  "savedJourneys": {
    "favTitle": "Favourite Journeys",
    "noFavsMessage": "No favourite journeys available",
    "recentTitle": "Recent Journeys",
    "noRecentsMessage": "No recent journeys available",
    "stopsHeader": "Journey",
    "tariffHeader": "Service",
    "goodsHeader": "Goods",
    "alert": {
      "addHeader": "Favourite this journey?",
      "addMessage": "Add an optional journey description",
      "editHeader": "Edit description",
      "editMessage": "Edit optional journey description",
      "descriptionPlaceholder": "Description"
    }
  },
  "location": {
    "permissionMessage": "To allow us to find your current location, please allow access"
  },
  "documents": "Documents",
  "goodsFields": {
    "unitWeight": "Weight",
    "unitHeight": "Height",
    "unitWidth": "Width",
    "unitDepth": "Depth",
    "unitValue": "Value",
    "unitCube": "Cube",
    "palletType": "Pallet Type",
    "palletSubType": "Pallet Sub Type",
    "nonDoc": "Non Doc",
    "volumetricWeight": "Volumetric Weight"
  },
  "viewBooking": {
    "guestInfo": "Guest Info",
    "parcelInfo": "Parcel Info",
    "palletInfo": "Pallet Info",
    "journeyRouteMessage": "The map represents an example route only and may not be the exact route the driver takes on your journey.",
    "jobFlags": "Options",
    "jobExtras": "Extras",
    "jobRefs": "References",
    "driverPhoto": "Driver photo",
    "vehicleImage": "Vehicle image",
    "tariffImage": "Service image",
    "proofOfDelivery": "Proof of delivery",
    "webInstructions": "Driver Notes",
    "price": "Price",
    "netPrice": "Net Price",
    "tax": "VAT",
    "totalPrice": "Total Price"
  },
  "dateRelative": {
    "lastWeek": "'Last' eeee 'at' p",
    "yesterday": "'Yesterday at' p",
    "today": "'Today at' p",
    "tomorrow": "'Tomorrow at' p",
    "nextWeek": "eeee 'at' p",
    "other": "P 'at' p"
  },
  "payment": {
    "cards": "Payment Cards",
    "noCards": "No payment cards available",
    "bookingPaymentTitle": "Booking Payment",
    "withCardEnding": "with card ending {cardNum}",
    "cardValidFrom": "valid from",
    "cardValidTo": "valid to",
    "addCard": "Add Card",
    "deleteCard": "Delete Card",
    "makeDefaultCard": "Make default card",
    "pay": "Pay",
    "savedCards": "Saved Cards",
    "otherPaymentMethod": "Other Method",
    "adflexNavWarning": "If you have already made a payment, you will still be charged"
  },
  "profileContact": {
    "telephone": "Telephone",
    "mobile": "Mobile",
    "account": "Account"
  }
}
